import { Box, Flex, Text, Button } from '@chakra-ui/react'
import { FC } from 'react'

const CELERY_FLOWER_URL =
  process.env.REACT_APP_CELERY_FLOWER_URL || 'http://40.81.201.213:5555/tasks'

/**
 * Active Tasks Monitor Component
 * Redirects to Celery Flower for task monitoring
 */
export const ActiveTasksMonitor: FC = () => {
  const handleOpenCeleryFlower = () => {
    window.open(CELERY_FLOWER_URL, '_blank')
  }

  return (
    <Box bgColor="white.50" borderRadius={4} padding="24px" w="100%">
      <Flex align="center" justifyContent="space-between" mb="16px">
        <Text
          fontSize="24px"
          fontWeight="700"
          letterSpacing="tighter"
          lineHeight="40px"
        >
          アクティブタスク
        </Text>
      </Flex>

      <Box
        bgColor="white.100"
        border="1px solid #E8ECEF"
        borderRadius="12px"
        padding="48px"
        textAlign="center"
      >
        <Text color="black.100" fontSize="16px" mb="24px">
          ℹ️ タスクの状態を確認するには、Celery Flowerにアクセスしてください
        </Text>
        <Button colorScheme="blue" size="md" onClick={handleOpenCeleryFlower}>
          🔗 Celery Flower を開く
        </Button>
      </Box>
    </Box>
  )
}
